import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBI_mCjTemfTYpDogEJ4wSrlQSbCXZvuFY",
  authDomain: "planet-protection-ui.firebaseapp.com",
  projectId: "planet-protection-ui",
  storageBucket: "planet-protection-ui.firebasestorage.app",
  messagingSenderId: "350362829680",
  appId: "1:350362829680:web:6fa18a872ece5b656f45b5",
  measurementId: "G-P66VMCDMGZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

export { auth };
export default app; 